var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view'),_vm._v(" "),_c('b-modal',{attrs:{"id":"noticePopup","title":_vm.noticeInfo.title,"title-tag":"h5","header-class":"jcc","centered":"","hide-footer":"","no-close-on-backdrop":"","no-close-on-esc":"","hide-header-close":""}},[_c('NoticePopup',{attrs:{"defaultInfo":_vm.noticeInfo}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6697b603","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 948
// module chunks = 3